export default "__VITE_ASSET__CTT1tnbu__"